// extracted by mini-css-extract-plugin
module.exports = {"Slide":"Slide-module--Slide--3GBLY","videoWrapper":"Slide-module--videoWrapper--2dCtk"};